module.exports = __webpack_public_path__ + "static/img/warehouse4.e68fbcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warehouse4.png
// module id = OlnP
// module chunks = 1